import React from 'react';

import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import { URLS } from 'rebook/apps/base/constants';

import LandingContentContainer from '../LandingContentContainer';


const FreeBooksBlock = ({ freeBooksBookset }) => (
  <div className="billetContainerNoOverflow">
    <div className="billetContainerWrapper">
      <LandingContentContainer
        link={URLS.catalogFreeBookList}
        title="Десятки тысяч бесплатных книг"
        linkText="Все бесплатные книги" />
      <p>Родная классика и проверенные временем бестселлеры всегда бесплатно</p>
    </div>
    <VerticalBookCardList bookList={freeBooksBookset && freeBooksBookset.books} />
  </div>
);

export default FreeBooksBlock;
